import {
    Avatar,
    BackButton,
    List,
    ListItem,
    ListItemDescription,
    ListItemIcon,
    ListItemName,
    ListItemText,
    MaterialIcon,
    View,
    ViewContent,
    ViewDescription,
    ViewHeader,
    ViewHeaderItem,
    ViewTitle
} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {Carrier} from "./model";
import {commonStyles} from "./commonStyles";
import {useLocalization} from "../i18n";


interface CarrierSelectionViewProps {
    onBack: () => void;
    onSelect: (carrier: Carrier) => void;
    carriers: ReadonlyArray<Carrier>;
}

export function CarrierSelectionView({onBack, onSelect, carriers}: CarrierSelectionViewProps) {
    const {t} = useLocalization();
    return (
        <View>
            <ViewHeader className={commonStyles.viewHeader}>
                <ViewHeaderItem>
                    <BackButton onClick={onBack} label={t("Back")}/>
                </ViewHeaderItem>
                <ViewHeaderItem fill>
                    <ViewTitle>{t("SelectCarrierTitle")}</ViewTitle>
                    <ViewDescription>{t("SelectCarrierDescription")}</ViewDescription>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={commonStyles.selectionViewContent}>
                <List>
                    {carriers.map(carrier => <CarrierItem key={carrier.abbreviation || carrier.name}
                                                          carrier={carrier} onSelect={onSelect}/>)}
                </List>
            </ViewContent>
        </View>
    );
}

interface CarrierItemProps {
    carrier: Carrier;
    onSelect: (carrier: Carrier) => void;
}

function CarrierItem({carrier, onSelect}: CarrierItemProps) {
    const handleClick = useCallback(() => onSelect(carrier), [onSelect, carrier]);
    return (
        <ListItem onClick={handleClick}>
            <ListItemIcon>
                <Avatar primary>{MaterialIcon.local_shipping}</Avatar>
            </ListItemIcon>
            <ListItemText>
                <ListItemName>{carrier.abbreviation || carrier.name}</ListItemName>
                <ListItemDescription>{carrier.abbreviation ? carrier.name : ""}</ListItemDescription>
            </ListItemText>
            <ListItemIcon>
                {MaterialIcon.chevron_right}
            </ListItemIcon>
        </ListItem>
    );
}
